<template>
    <div class="model_header">
        <div class="flex">
            <div class="flex1 text-align-left">
                <span class="model_title">整体评价<span class="require">*</span></span>
                <!-- 评分组件 -->
                <FeedBackRate :userScore="userScore" :score="score"/>
            </div>
        </div>
    </div>
</template>

<script>
import FeedBackRate from './FeedBackRate';

export default {
  props: ['score', 'userScore'],
  name: 'FeedBackHeader',
  components: {
      FeedBackRate
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.require {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/feedBackElement/FeedBackHeader.vue